import { useCallback, useEffect, useState } from 'react';
import { useCountryTagsQuery } from 'api';
import { FormInstance } from 'components';

export const useFilters = ({ form, resetFilters }: { form: FormInstance; resetFilters: () => void }) => {
  const { data: tagData = [], isSuccess: isTagSuccess } = useCountryTagsQuery();
  const [availableTags, setAvailableTags] = useState<string[]>([]);

  const handleTagSelect = useCallback((tag: string) => {
    setAvailableTags((prevState) => prevState.filter((_tag) => _tag !== tag));
  }, []);

  const handleTagRemove = useCallback((tag: string) => {
    setAvailableTags((prevState) => [tag, ...prevState]);
  }, []);

  useEffect(() => {
    if (isTagSuccess) {
      setAvailableTags(tagData);
    }
  }, [isTagSuccess, tagData]);

  const clearFilters = useCallback(() => {
    form.resetFields();
    setAvailableTags(tagData);
    resetFilters();
  }, [form, tagData, resetFilters]);

  return {
    availableTags,
    handleTagSelect,
    handleTagRemove,
    clearFilters,
  };
};
